var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fade-in-fwd", attrs: { id: "#step-2" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-6" }, [
        _c("label", { attrs: { for: "" } }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$resourceString[
                  "myProject.Project.AddItemModal.ProductStep1.ProductType.Label"
                ]
              ) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-2 justify-content-between align-items-center" },
          [
            _c("div", { staticClass: "input-group" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.step2.productType,
                      expression: "step2.productType"
                    }
                  ],
                  staticClass: "form-control form-control-sm text-uppercase",
                  attrs: {
                    name: "productType",
                    id: _vm.step2.productType,
                    required: "required",
                    disabled: _vm.isDisabled
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.step2,
                          "productType",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      _vm.handleProductType
                    ]
                  }
                },
                [
                  _c(
                    "option",
                    {
                      attrs: { value: "", disabled: "" },
                      domProps: { selected: true }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$resourceString[
                            "myProject.Project.AddItemModal.ProductStep1.ProductType.Placeholder"
                          ]
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.getContentWizardData.productType, function(
                    item,
                    index
                  ) {
                    return _c(
                      "option",
                      { key: index, staticClass: "dropdown-item" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.toLowerCase()) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("label", { attrs: { for: "" } }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$resourceString[
                  "myProject.Project.AddItemModal.ProductStep1.AddProduct.Label"
                ]
              ) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-2  justify-content-between align-items-center" },
          [
            _c(
              "div",
              {
                staticClass: "input-group-append my-project-input-container",
                on: {
                  mouseout: function($event) {
                    _vm.showClearIcon = false
                  },
                  mouseover: function($event) {
                    _vm.showClearIcon = true
                  }
                }
              },
              [
                _vm.step2.productTitle && _vm.showClearIcon
                  ? _c("span", {
                      staticClass:
                        "png-icon png-icon-icons-glyph--k-close my-project-search-icon my-project-clear-icon",
                      on: { click: _vm.clearProductTitle }
                    })
                  : _c(
                      "svg",
                      {
                        staticClass: "bi bi-search my-project-search-icon",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          fill: "currentColor",
                          viewBox: "0 0 16 16"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
                          }
                        })
                      ]
                    )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "search-container d-flex flex-wrap" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.step2.productTitle,
                    expression: "step2.productTitle"
                  }
                ],
                staticClass:
                  "form-control my-project-add-product text-capitalize",
                attrs: {
                  type: "text",
                  id: _vm.step2.productTitle,
                  placeholder: "",
                  disabled: !_vm.getisProductSearchDisabled
                },
                domProps: { value: _vm.step2.productTitle },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.step2, "productTitle", $event.target.value)
                    },
                    _vm.updateSearchQuery
                  ],
                  focus: function($event) {
                    _vm.showClearIcon = true
                  }
                }
              }),
              _vm._v(" "),
              _vm.filteredProducts.length > 0
                ? _c(
                    "ul",
                    {
                      staticClass: "search-result-box text-capitalize p-0",
                      class: _vm.step2.productTitle ? "" : "d-none"
                    },
                    _vm._l(_vm.filteredProducts, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "search-result__value p-3",
                          on: {
                            click: function($event) {
                              return _vm.selectProduct(item)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(item.styleName + " - " + item.styleNumber)
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("label", { attrs: { for: "" } }, [
          _vm._v(
            _vm._s(
              _vm.$resourceString[
                "myProject.Project.AddItemModal.ProductStep1.ProjectGridSize.Label"
              ]
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-4" },
        [
          _c("my-project-radio-field", {
            attrs: {
              options: _vm.getContentWizardData.radioOptions,
              name: "size"
            },
            model: {
              value: _vm.step2.size,
              callback: function($$v) {
                _vm.$set(_vm.step2, "size", $$v)
              },
              expression: "step2.size"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group mt-32" },
      [
        _c(
          "label",
          { staticClass: "gray-bold", attrs: { for: "#Step2Description" } },
          [
            _vm._v(
              _vm._s(
                _vm.$resourceString[
                  "myProject.Project.AddItemModal.ProductStep1.ProjectDescription.Label"
                ]
              ) + "\n      "
            ),
            _c("span", { staticClass: "optional-field ml-3" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$resourceString["contentWizard.Label.Field.Optional"]
                  ) +
                  " "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("my-project-description-field", {
          attrs: {
            customClass: "form-control",
            maxlength: "400",
            fieldId: "description",
            placeholder:
              _vm.$resourceString[
                "myProject.ProductItem.Description.Placeholder"
              ]
          },
          model: {
            value: _vm.step2.description,
            callback: function($$v) {
              _vm.$set(_vm.step2, "description", $$v)
            },
            expression: "step2.description"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }